(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("reactReviews", ["react"], factory);
	else if(typeof exports === 'object')
		exports["reactReviews"] = factory(require("react"));
	else
		root["reactReviews"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition